import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Celebration from '@animation/celebration';
import ImageBlock from '@component/common/block/image-block';
import TextBlock from '@component/common/block/text-block';
import otterReadImage from '@asset/image/otter-read.png';
import * as color from '@constant/color';
import * as size from '@constant/size';
import TextButton from '@design-system/text-button';
import Gap from '@component/common/gap';
import { useTypedDispatch } from '@hook/common/useStore';
import { actions as modalActions } from '@store/slice/modal-slice';
import { IStudyCelebrationModalData } from '@datatype/iyagigo/type';
import { ETheme } from '@datatype/type';
import { IYAGIGO_PATH } from '@constant/iyagigo/route-path';

interface IProps {
  data: IStudyCelebrationModalData['data'];
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  width: ${size.MEDIUM_MODAL_WIDTH};
`;

const StudyCelebrationModal: React.FC<IProps> = ({ data }) => {
  const { title, description } = data;
  const dispatch = useTypedDispatch();
  const navigate = useNavigate();

  const handleGoHomeClick = () => {
    dispatch(modalActions.hideModal());
    navigate(IYAGIGO_PATH.HOME_BEGIN_PATH);
  };

  return (
    <Wrapper>
      <Gap height={size.MARGIN_2} />
      <Celebration repeat width='100%' height='180px' alignY='bottom'>
        <ImageBlock src={otterReadImage} alt='책을 읽으며 웃는 수달' design={{ image: { height: '120px' } }} />
      </Celebration>
      <Gap height={size.MARGIN_2} />
      <TextBlock text={title} design={{ text: { size: 'large', color: color.BROWN_1, bold: true } }} />
      <Gap height={size.MARGIN_1} />
      <TextBlock text={description} design={{ text: { size: 'medium', color: color.BLACK_2, bold: false } }} />
      <Gap height={size.MARGIN_3} />
      <TextButton
        theme={ETheme.BROWN}
        kind='filled'
        size='medium'
        shape='pill'
        width='100%'
        text='홈으로 돌아가기'
        handleClick={handleGoHomeClick}
      />
    </Wrapper>
  );
};

export default StudyCelebrationModal;
